<template>
  <div class="table">
    <div class="container">
     <div>
         <p class="icon-jujue closeBtn" @click="routerBack"></p>
     </div>
     <div class="handle-box">
          <el-row type="flex"  align="middle">
            <!-- <el-button  size="mini" type="primary" @click="addData('detailForm')">新增</el-button> -->
            <el-button v-acl="RMC_ASL_SAVE" size="mini" type="primary" @click="saveData('detailForm')">保存</el-button>
            <el-button v-if="detailForm.aslStatus=='Draft'||!this.$route.query.id" v-acl="RMC_ASL_SUBMIT" size="mini"  type="primary" @click="submitData('detailForm')">提交</el-button>
          </el-row>
     </div>

     
    
    <div class="handle-box">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">ASL Maintain</p>
        </div>
        <el-form :model="detailForm" ref="detailForm" :rules="rules" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row style="margin-top:8px;"  align="middle">
             <el-col :span="6">
                 <el-form-item label="Category3" prop="category3Code">
                     <el-select v-model="detailForm.category3Code" @change="changeCategory3" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.object" :value="item.key"></el-option>
                     </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="Sponsor" prop="sponsorName">
                    <el-input v-model="detailForm.sponsorName"  placeholder="从供应商集团选择" >
                      <el-button @click="onFacility" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="ASL" prop="aslName">
                    <el-input v-model="detailForm.aslName" maxlength="100" @blur="getAslName" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="ASL Group" prop="aslGroupCode">
                     <el-select  v-model="detailForm.aslGroupCode" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in aslGroupCodeList" :label="item.aslGroupName" :value="item.aslGroupCode"></el-option>
                     </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="Ownership" prop="ownership" :rules="{required:isPoultry,message:'请选择Ownership'}">
                     <el-select v-model="detailForm.ownership" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in ownershipOptions" :label="item.object" :value="item.key"></el-option>
                     </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="国内/国外" prop="domesticOrOverseas">
                     <el-select v-model="detailForm.domesticOrOverseas" @change="changeDomesticOrOverseas" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in domesticOrOverseas" :label="item.object" :value="item.key"></el-option>
                     </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="国家" prop="countryRegion" :rules="{required:isCountryRegion,message:'请选择国家'}">
                     <el-input v-model="detailForm.countryRegion" maxlength="100" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="状态" prop="aslStatus">
                     <el-select disabled v-model="detailForm.aslStatus"  clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item.object" :value="item.key"></el-option>
                     </el-select>
                 </el-form-item>
             </el-col>
              <el-col :span="12" v-if="$route.query.id">
                  <el-form-item label="上次修改原因"  prop="momentUpdateReason">
                      <el-input  type="textarea" disabled maxlength="1000" show-word-limit v-model="momentUpdateReason" ></el-input>
                  </el-form-item>
              </el-col>
              
             <el-col :span="12">
                 <el-form-item label="修改原因" prop="updateReason" >
                     <el-input class="updateReason" type="textarea" placeholder="请输入内容" maxlength="1000" show-word-limit v-model="detailForm.updateReason" ></el-input>
                 </el-form-item>
             </el-col>
          </el-row>
        </el-form>
    </div>

    <div class="handle-box">
       <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">操作日志</p>
       </div>

       <el-table :data="logTableData"  max-height="500"   border highlight-current-row style="margin-top: 10px ;" class="PQCP"  show-overflow="ellipsis" >
        <el-table-column prop="createDate" label="操作时间" width="180"></el-table-column>
        <el-table-column prop="operatorName" label="操作人" ></el-table-column>
        <el-table-column prop="action" label="操作描述" ></el-table-column>
        <el-table-column prop="comments" label="修改原因" ></el-table-column>
      </el-table>
    </div>

    <el-dialog title="Sponsor主数据" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <facilityList v-if="dialogVisible" @selectData="selectData"></facilityList>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import commonFunction from "@/utils/dataTableUtils";
import inventoryList from '@/components/page/RMC/Protein/rmcDrugDosage/inventoryList'
import aslApi from "@/api/rmcProtein/asl"; 
import QBRApi from "@/api/QBR/index";
import facilityList from "./facilityList.vue";
import { json } from "body-parser";

export default {
  name: '',
  components: {
    inventoryList,
    IcSelect,
    facilityList,
    // detailDialog
  },
  data() {
    return {
      momentUpdateReason:"",
      isCountryRegion:false,
      logTableData:[],
      isPoultry:false,
      getDetailInfo:[],
      aslGroupCodeList:[],
      statusList: [],
      ownershipOptions:[],
        domesticOrOverseas:[],
        dialogVisible:false,
        identity:localStorage.getItem('ms_emplFlag'),
        categoryList3: [],
        detailForm: {
          category3Code:"",
          sponsorName:"",
          aslName:"",
          aslGroupCode:"",
          ownership:"",
          domesticOrOverseas:"",
          countryRegion:"",
          aslStatus:"Draft"
        },
        showDetailDialog:false,
        totalCount:"",
        testObj:{},
        rules:{
          category3Code: [
            { required: true, message: '请选择Category3', trigger: 'change' }
          ],
          sponsorName:[
            { required: true, message: '请选择Sponsor', trigger: 'blur' }
          ],
          aslGroupCode: [
            { required: true, message: '请选择ASL Group', trigger: 'change' }
          ],
          aslName: [
            { required: true, message: '请输入ASL', trigger: 'blur' }
          ],
          domesticOrOverseas: [
            { required: true, message: '请选择国内/国外', trigger: 'change' }
          ],
        },
    }
  },
  created() {
    this.getCategory3()
  },
  mounted(){
    if(this.$route.query.id){
      this.queryData();
      this.queryActionList()
    }
  },
  methods: {
    queryActionList(){
      aslApi.queryActionList({rmcProteinAslId:this.$route.query.id}).then((res)=>{
        console.log("查看日志===",res)
        this.logTableData=res.resultData
      })
    },
    changeCategory3(val){
      if(val=='10101'){
        this.isPoultry=true
      }else{
        this.isPoultry=false
      }
    },
    queryData() {
      aslApi.aslDetail({},this.$route.query.id).then((res)=>{
        console.log("获取的详情数据====",res)
          if(res.code==200){
            if(res.data.updateReason){
              this.momentUpdateReason=res.data.updateReason
              res.data.updateReason=''
            }
            if(res.data.category3Code=='10101'){
              this.isPoultry=true
            }else{
              this.isPoultry=false
            }
            this.getAslGroup(res.data.sponsorCode)
            this.detailForm=res.data
          }else{
            this.$message.error(res.msg)
          }
      })
    },
    onFacility(){
      this.dialogVisible=true
    },
    addData(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
          aslApi.addAsl(this.detailForm).then((res)=>{
              if(res.meta.code==200){
                this.$message.success('添加成功')
                this.routerBack()
              }else{
                this.$message.error(res.meta.msg)
              }
          })
          } else {
            console.log('error submit!!');
              return false;
          }
      });
    },
    changeDomesticOrOverseas(val){
      if(val=='Domestic'){
        this.isCountryRegion=false
        this.$set(this.detailForm,'countryRegion','中国')
      }else{
        this.isCountryRegion=true
        this.$set(this.detailForm,'countryRegion','')
      }
      console.log('vvvvvvvvvv',val)
    },
    saveData(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.testObj.aslGroupName==this.detailForm.aslGroupCode){
              this.detailForm.aslGroupName=""
              this.detailForm.aslGroupCode=""
              this.$refs['detailForm'].clearValidate(['aslGroupCode']);
            }
            if(!this.$route.query.id){
              aslApi.addAsl(this.detailForm).then((res)=>{
                  if(res.meta.code==200){
                    this.$message.success('添加成功')
                    this.queryActionList()
                    this.routerBack()
                  }else{
                    this.$message.error(res.meta.msg)
                  }
              })
            }else{
              if(!this.detailForm.updateReason){
                this.detailForm.updateReason=this.momentUpdateReason
              }
              aslApi.saveAsl(this.detailForm,this.detailForm.rmcProteinAslId).then((res)=>{
                  if(res.meta.code==200){
                    this.$message.success('保存成功')
                    this.queryActionList()
                    this.routerBack()
                  }else{
                    this.$message.error(res.meta.msg)
                  }
              })
            }
          } else {
            console.log('error submit!!');
              return false;
          }
      });
    },
    submitData(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.testObj.aslGroupName==this.detailForm.aslGroupCode){
              this.detailForm.aslGroupName=""
              this.detailForm.aslGroupCode=""
              this.$refs['detailForm'].clearValidate(['aslGroupCode']);
            }
            let id=!this.detailForm.rmcProteinAslId?0:this.detailForm.rmcProteinAslId
            if(!this.detailForm.updateReason){
                this.detailForm.updateReason=this.momentUpdateReason
            }
            aslApi.submitAsl(this.detailForm,id).then((res)=>{
              if(res.meta.code==200){
                this.$message.success('提交成功')
                this.queryActionList()
                this.routerBack()
              }else{
                this.$message.error(res.meta.msg)
              }
            })
          } else {
            return false;
          }
      });
    },
    routerBack(){
        this.$router.back();
    },
    selectData(data){
      console.log("获取的数据======",data)
      this.getDetailInfo=data
      this.$set(this.detailForm,'sponsorName',data[0].supplierName)
      this.$set(this.detailForm,'sponsorCode',data[0].supplierCode)
      this.$refs.detailForm.clearValidate('sponsorName');
      this.$set(this.detailForm,'aslGroupCode',"")
      this.getAslGroup(data[0].supplierCode)

      this.dialogVisible=false
    },
    getAslGroup(id){
      aslApi.allAslGroup({},id).then((res)=>{
        if(res.code==200){
          this.aslGroupCodeList=res.data
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    getCategory3(){
      aslApi.getCategory3(['rmc.RmcCategory3','rmc.RmcProteinAslOwnership','rmc.RmcDomesticOrOverseas','rmc.RmcProteinAslStatus']).then((res)=>{
        if(res.code==200){
          this.categoryList3=res.data['rmc.RmcCategory3'].filter((v)=>{
            return v.cascadeKey=='protein'
          })
          this.domesticOrOverseas=res.data['rmc.RmcDomesticOrOverseas']
          this.ownershipOptions=res.data['rmc.RmcProteinAslOwnership']
          this.statusList=res.data['rmc.RmcProteinAslStatus']
        }else{
          this.$message.error(res.msg)
        }
        console.log("获取的列表====",res)
      })
    },
    getAslName(){
      console.log("获取失焦的数据=====",this.detailForm.aslName)
      if(!this.$route.query.id){
        let str=this.aslGroupCodeList.findIndex((a)=>{
          a.aslGroupName==this.detailForm.aslName
        })
        if(str==-1){   //没找到
          if(JSON.stringify(this.testObj)!='{}'){
            this.aslGroupCodeList.splice(this.aslGroupCodeList.length-1,1)
          }
          this.testObj={}
          this.testObj.aslGroupCode=this.detailForm.aslName,
          this.testObj.aslGroupName=this.detailForm.aslName
          this.aslGroupCodeList.push(this.testObj)
          this.$set(this.detailForm,'aslGroupCode',this.detailForm.aslName)
        }
        console.log("111111111",this.testObj)
        console.log("222222222",this.aslGroupCodeList)
      }
      
      // console.log("strrrrr",str)
      // console.log("aslGroupCodeList",this.aslGroupCodeList)
      // if(!this.$route.query.id){    //判断是新增的时候把输入的数据存到group
      //   this.aslGroupCodeList.push(obj)
      //   // this.$set(this.detailForm,'aslGroupCode',this.detailForm.aslName)
      // }
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.searchForm .el-col{
    margin-top: 10px;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
